// libraries.
import { PolygonF } from '@react-google-maps/api';
import { useSelector, useDispatch } from 'react-redux';
import { Fragment } from 'react';

// selectors.
import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';
import { getMedianZoneCode } from '@domains/median-zones/store/slices/medianZones.slice';

// hooks.
import {
  getIsModePolygonEdit,
  setHoveredPolygonId,
  setPathPolygonByPolygonId,
} from '@domains/save-polygons/store/slices/modePolygon.slice';
import { getListPolygons } from '@domains/save-polygons';
import { handleOptionsPolygonFromActive } from './utils/optionsPolygons';
import { getPathFromPolygon, PolygonIdLabel } from '@domains/google-map';

interface ListPolygonsProps {
  showPolygons?: boolean;
}

export const ListPolygons = ({ showPolygons = true }: ListPolygonsProps) => {
  const dispatch = useDispatch();
  const agent = useSelector(getEmail);
  const medianZoneCode = useSelector(getMedianZoneCode);
  const isPolygonModeEdit = useSelector(getIsModePolygonEdit);
  const listPolygons = useSelector(getListPolygons);

  if (!showPolygons) return null;

  return (
    <>
      {listPolygons.map(polygon => {
        if (polygon.hidden) return null;

        const isInSameMedianZone =
          polygon.median_zone_id?.toString() === medianZoneCode;
        const isBlocking = polygon.polygon_type === 'blocking';

        const optionsPolygons = handleOptionsPolygonFromActive({
          active: polygon.active,
          edited: polygon.edited,
          isHovered: polygon.select,
          median_zone_id: polygon.median_zone_id,
          medianZoneCode: medianZoneCode,
          polygon_type: polygon.polygon_type,
        });

        const path = polygon.polygon.map(point => ({
          lat: point.lat,
          lng: point.lng,
        }));

        return (
          <Fragment key={polygon.polygon_id}>
            <PolygonF
              path={path}
              onMouseOver={() =>
                dispatch(setHoveredPolygonId(polygon.polygon_id))
              }
              onMouseOut={() => dispatch(setHoveredPolygonId(null))}
              editable={isPolygonModeEdit && (isInSameMedianZone || isBlocking)}
              options={optionsPolygons}
              onEdit={(e: google.maps.Polygon) => {
                const path = getPathFromPolygon(e);
                dispatch(
                  setPathPolygonByPolygonId({
                    polygonId: polygon.polygon_id,
                    path: path,
                    agent: agent,
                  })
                );
              }}
            />
            <PolygonIdLabel id={polygon.polygon_id} path={path} />
          </Fragment>
        );
      })}
    </>
  );
};
